module.exports = __webpack_public_path__ + "static/img/hand.472f55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/hand.png
// module id = MAZ7
// module chunks = 213